<div [formGroup]="form" class="gup-C-filterCard">

    <section class="--demi">

        <article>

            <kal-form-field *ngIf="!beneficiaryId">

                <app-beneficiary-picker formControlName="IdBenef"
                                        label="Bénéficiaire">
                </app-beneficiary-picker>

            </kal-form-field>

            <kal-form-field>

                <kal-select formControlName="StatutsFactures"
                            id="activity_sales_invoices_filters_StatutsFactures"
                            label="Statut"
                            placeholder="Tous"
                            multiple>

                    <kal-option *ngFor="let statutFacture of statutsFactures"
                                [value]="statutFacture.code">
                        {{ statutFacture.label }}
                    </kal-option>

                </kal-select>

            </kal-form-field>

            <kal-form-field class="without-label">

                <kal-checkbox formControlName="IsSupprimer"
                            id="activity_sales_invoices_filters_IsSupprimer"
                            label="Afficher les factures supprimées">
                </kal-checkbox>

            </kal-form-field>

        </article>

        <article>

            <kal-form-field>

                <kal-select formControlName="TypesFactures"
                            id="activity_sales_invoices_filters_TypesFactures"
                            label="Types de facture"
                            placeholder="Tous"
                            multiple>

                    <kal-option *ngFor="let type of typesFactures"
                                [value]="type.code">
                        {{ type.label }}
                    </kal-option>

                </kal-select>

            </kal-form-field>

            <app-date-range formControlName="DateFacture"></app-date-range>

        </article>

    </section>

</div>
